import React from 'react'
import { I18n } from 'react-redux-i18n'

export default ({ jobAssignment }) => (
  <tr className="hover:bg-gray-50 transition-colors">
    <td className="px-4 py-3 text-sm text-gray-800">
      {jobAssignment.service.displayName}
    </td>
    <td className="px-4 py-3 text-sm text-gray-800">
      {jobAssignment.reservation.mainPax.fullName}
    </td>
    <td className="px-4 py-3 text-sm text-gray-600">
      {jobAssignment.issuedServiceDateTime.format(
        I18n.t('date.shortDateTimeFormat'),
      )}
    </td>
  </tr>
)
